import React from 'react';

export function CommonChestIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="28" width="52" height="28" rx="3" fill="#7B4E2D"/>
      <rect x="6" y="28" width="52" height="28" rx="3" fill="url(#c_cw)" fillOpacity="0.3"/>
      <path d="M6 28 Q6 14 32 14 Q58 14 58 28Z" fill="#8B5E38"/>
      <path d="M6 28 Q6 14 32 14 Q58 14 58 28Z" fill="url(#c_cw)" fillOpacity="0.2"/>
      <line x1="16" y1="28" x2="16" y2="56" stroke="#5A3A1F" strokeWidth="1" opacity="0.5"/>
      <line x1="26" y1="28" x2="26" y2="56" stroke="#5A3A1F" strokeWidth="1" opacity="0.5"/>
      <line x1="38" y1="28" x2="38" y2="56" stroke="#5A3A1F" strokeWidth="1" opacity="0.5"/>
      <line x1="48" y1="28" x2="48" y2="56" stroke="#5A3A1F" strokeWidth="1" opacity="0.5"/>
      <rect x="4" y="37" width="56" height="5" rx="1" fill="#555" stroke="#777" strokeWidth="0.5"/>
      <rect x="4" y="46" width="56" height="5" rx="1" fill="#555" stroke="#777" strokeWidth="0.5"/>
      <rect x="4" y="26" width="56" height="4" rx="1" fill="#555" stroke="#777" strokeWidth="0.5"/>
      <rect x="26" y="35" width="12" height="10" rx="2" fill="#B8860B"/>
      <rect x="29" y="38" width="6" height="4" rx="1" fill="#5A3A1F"/>
      <circle cx="8" cy="39" r="1.5" fill="#888"/>
      <circle cx="56" cy="39" r="1.5" fill="#888"/>
      <circle cx="8" cy="48" r="1.5" fill="#888"/>
      <circle cx="56" cy="48" r="1.5" fill="#888"/>
      <defs>
        <linearGradient id="c_cw" x1="6" y1="14" x2="58" y2="56" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity="0.4"/>
          <stop offset="1" stopColor="#000" stopOpacity="0.2"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export function UncommonChestIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="30" width="52" height="26" rx="3" fill="#4A5568"/>
      <path d="M6 30 Q6 16 32 16 Q58 16 58 30Z" fill="#556"/>
      <path d="M8 38 H56" stroke="#3a3a4a" strokeWidth="0.8" opacity="0.7"/>
      <path d="M8 46 H56" stroke="#3a3a4a" strokeWidth="0.8" opacity="0.7"/>
      <path d="M20 30 V56" stroke="#3a3a4a" strokeWidth="0.8" opacity="0.5"/>
      <path d="M44 30 V56" stroke="#3a3a4a" strokeWidth="0.8" opacity="0.5"/>
      <rect x="7" y="31" width="50" height="24" rx="2" stroke="#2ecc71" strokeWidth="1.5" fill="none" opacity="0.6"/>
      <path d="M7 30 Q7 17 32 17 Q57 17 57 30" stroke="#2ecc71" strokeWidth="1.5" fill="none" opacity="0.5"/>
      <rect x="4" y="27" width="56" height="5" rx="1" fill="#667" stroke="#2ecc71" strokeWidth="0.5"/>
      <path d="M28 38 L32 34 L36 38 L34 46 L30 46Z" fill="#2ecc71"/>
      <path d="M28 38 L32 34 L36 38 L34 46 L30 46Z" fill="url(#u_egem)"/>
      <path d="M30 35 L32 34 L33 36Z" fill="#fff" opacity="0.5"/>
      <text x="9" y="26" fontSize="7" fill="#2ecc71" opacity="0.7" fontFamily="monospace">᛭</text>
      <text x="49" y="26" fontSize="7" fill="#2ecc71" opacity="0.7" fontFamily="monospace">᛭</text>
      <defs>
        <radialGradient id="u_egem" cx="50%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#90ff90"/>
          <stop offset="100%" stopColor="#1a7a40"/>
        </radialGradient>
      </defs>
    </svg>
  );
}

export function RareChestIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="29" width="54" height="27" rx="4" fill="#1a2a4a"/>
      <path d="M5 29 Q5 14 32 14 Q59 14 59 29Z" fill="#1f3461"/>
      <path d="M14 22 Q32 17 50 22" stroke="#3498db" strokeWidth="1.2" fill="none" opacity="0.8"/>
      <path d="M18 25 Q32 21 46 25" stroke="#3498db" strokeWidth="0.8" fill="none" opacity="0.6"/>
      <circle cx="32" cy="22" r="5" stroke="#3498db" strokeWidth="1" fill="none" opacity="0.5"/>
      <circle cx="32" cy="22" r="3" stroke="#3498db" strokeWidth="0.6" fill="none" opacity="0.3"/>
      <rect x="4" y="26" width="56" height="5" rx="1" fill="#2a3a5a" stroke="#3498db" strokeWidth="1"/>
      <rect x="4" y="38" width="56" height="3" rx="1" fill="#1a2a3a" stroke="#3498db" strokeWidth="0.6" opacity="0.7"/>
      <rect x="4" y="48" width="56" height="3" rx="1" fill="#1a2a3a" stroke="#3498db" strokeWidth="0.6" opacity="0.7"/>
      <path d="M29 36 L32 32 L35 36 L34 42 L30 42Z" fill="#3498db"/>
      <path d="M29 36 L32 32 L35 36 L34 42 L30 42Z" fill="url(#r_sapphire)"/>
      <path d="M30 33 L32 32 L33 34Z" fill="#fff" opacity="0.5"/>
      <path d="M29 36 L32 32 L35 36 L34 42 L30 42Z" stroke="#60c0ff" strokeWidth="0.8" fill="none"/>
      <path d="M8 30 L6 28 L10 28 Z" fill="#3498db" opacity="0.6"/>
      <path d="M56 30 L58 28 L54 28 Z" fill="#3498db" opacity="0.6"/>
      <path d="M8 54 L6 56 L10 56 Z" fill="#3498db" opacity="0.6"/>
      <path d="M56 54 L58 56 L54 56 Z" fill="#3498db" opacity="0.6"/>
      <rect x="5" y="29" width="54" height="27" rx="4" fill="none" stroke="#3498db" strokeWidth="1.5" opacity="0.4"/>
      <defs>
        <radialGradient id="r_sapphire" cx="40%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#9ae0ff"/>
          <stop offset="100%" stopColor="#1060b0"/>
        </radialGradient>
      </defs>
    </svg>
  );
}

export function EpicChestIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="28" width="56" height="28" rx="4" fill="#1a0a2e"/>
      <path d="M4 28 Q4 12 32 12 Q60 12 60 28Z" fill="#230d3e"/>
      <path d="M20 20 L25 26 L22 28" stroke="#bf5fff" strokeWidth="0.8" opacity="0.7"/>
      <path d="M44 20 L39 26 L42 28" stroke="#bf5fff" strokeWidth="0.8" opacity="0.7"/>
      <rect x="3" y="25" width="58" height="5" rx="1.5" fill="#2a1040" stroke="#bf5fff" strokeWidth="1.2"/>
      <rect x="3" y="38" width="58" height="3" rx="1" fill="#150820" stroke="#bf5fff" strokeWidth="0.7" opacity="0.7"/>
      <rect x="3" y="48" width="58" height="3" rx="1" fill="#150820" stroke="#bf5fff" strokeWidth="0.7" opacity="0.7"/>
      <ellipse cx="32" cy="36" rx="6" ry="4" fill="#1a0a2e" stroke="#bf5fff" strokeWidth="1.2"/>
      <ellipse cx="32" cy="36" rx="3" ry="3" fill="#bf5fff"/>
      <circle cx="32" cy="36" r="1.5" fill="#0a0015"/>
      <ellipse cx="32" cy="36" rx="6" ry="4" stroke="#df9fff" strokeWidth="0.5" fill="none" opacity="0.4"/>
      <ellipse cx="32" cy="36" rx="8" ry="6" fill="none" stroke="#bf5fff" strokeWidth="0.5" opacity="0.3"/>
      <path d="M7 29 L4 26 M4 26 L7 26" stroke="#bf5fff" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M57 29 L60 26 M60 26 L57 26" stroke="#bf5fff" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M7 54 L4 57 M4 57 L7 57" stroke="#bf5fff" strokeWidth="1.2" strokeLinecap="round"/>
      <path d="M57 54 L60 57 M60 57 L57 57" stroke="#bf5fff" strokeWidth="1.2" strokeLinecap="round"/>
      <circle cx="31" cy="35" r="1" fill="#fff" opacity="0.4"/>
      <rect x="4" y="28" width="56" height="28" rx="4" fill="none" stroke="#bf5fff" strokeWidth="1.5" opacity="0.35"/>
      <path d="M4 28 Q4 12 32 12 Q60 12 60 28" fill="none" stroke="#bf5fff" strokeWidth="1.5" opacity="0.35"/>
    </svg>
  );
}

export function LegendaryChestIcon({ size = 64 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {[0,30,60,90,120,150,180,210,240,270,300,330].map((a, i) => (
        <line key={i}
          x1={32 + Math.cos(a * Math.PI / 180) * 8}
          y1={28 + Math.sin(a * Math.PI / 180) * 8}
          x2={32 + Math.cos(a * Math.PI / 180) * 16}
          y2={28 + Math.sin(a * Math.PI / 180) * 16}
          stroke="#FFD700" strokeWidth="1.5" opacity="0.25"
        />
      ))}
      <rect x="5" y="30" width="54" height="26" rx="4" fill="#1a1200"/>
      <rect x="5" y="30" width="54" height="26" rx="4" fill="url(#l_body)"/>
      <path d="M5 30 Q5 13 32 13 Q59 13 59 30Z" fill="#1e1400"/>
      <path d="M5 30 Q5 13 32 13 Q59 13 59 30Z" fill="url(#l_lid)"/>
      <rect x="3" y="27" width="58" height="5" rx="2" fill="url(#l_band)"/>
      <rect x="3" y="39" width="58" height="4" rx="1.5" fill="url(#l_band2)" opacity="0.9"/>
      <rect x="3" y="49" width="58" height="4" rx="1.5" fill="url(#l_band2)" opacity="0.9"/>
      <path d="M10 24 Q16 18 22 22 Q18 25 14 28Z" fill="#FFD700" opacity="0.6"/>
      <path d="M54 24 Q48 18 42 22 Q46 25 50 28Z" fill="#FFD700" opacity="0.6"/>
      <path d="M32 28 L27 34 L29 42 L32 44 L35 42 L37 34Z" fill="url(#l_flamegem)"/>
      <path d="M32 28 L27 34 L29 42 L32 44 L35 42 L37 34Z" stroke="#FFD700" strokeWidth="1"/>
      <path d="M32 30 L29 35 L30 40 L32 41 L34 40 L35 35Z" fill="#FF8C00" opacity="0.7"/>
      <path d="M32 31 L30.5 35 L31 39 L32 40 L33 39 L33.5 35Z" fill="#FFD700" opacity="0.5"/>
      <circle cx="32" cy="38" r="2" fill="#fff" opacity="0.25"/>
      <path d="M30 30 L32 28 L33 30Z" fill="#fff" opacity="0.5"/>
      <circle cx="9" cy="41" r="2" fill="url(#l_rivet)"/>
      <circle cx="55" cy="41" r="2" fill="url(#l_rivet)"/>
      <circle cx="9" cy="51" r="2" fill="url(#l_rivet)"/>
      <circle cx="55" cy="51" r="2" fill="url(#l_rivet)"/>
      <rect x="5" y="30" width="54" height="26" rx="4" fill="none" stroke="#FFD700" strokeWidth="1.5" opacity="0.5"/>
      <path d="M5 30 Q5 13 32 13 Q59 13 59 30" fill="none" stroke="#FFD700" strokeWidth="1.5" opacity="0.5"/>
      <defs>
        <linearGradient id="l_body" x1="5" y1="30" x2="59" y2="56" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#8B6914" stopOpacity="0.5"/>
          <stop offset="50%" stopColor="#FFD700" stopOpacity="0.15"/>
          <stop offset="100%" stopColor="#5a4000" stopOpacity="0.4"/>
        </linearGradient>
        <linearGradient id="l_lid" x1="5" y1="13" x2="59" y2="30" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFD700" stopOpacity="0.2"/>
          <stop offset="100%" stopColor="#8B6914" stopOpacity="0.1"/>
        </linearGradient>
        <linearGradient id="l_band" x1="0" y1="0" x2="0" y2="5" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFE55C"/>
          <stop offset="50%" stopColor="#B8860B"/>
          <stop offset="100%" stopColor="#FFE55C"/>
        </linearGradient>
        <linearGradient id="l_band2" x1="0" y1="0" x2="0" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#D4A017"/>
          <stop offset="50%" stopColor="#8B6914"/>
          <stop offset="100%" stopColor="#D4A017"/>
        </linearGradient>
        <linearGradient id="l_flamegem" x1="32" y1="28" x2="32" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FF6600"/>
          <stop offset="50%" stopColor="#FF8C00"/>
          <stop offset="100%" stopColor="#FFD700"/>
        </linearGradient>
        <radialGradient id="l_rivet" cx="40%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#FFE55C"/>
          <stop offset="100%" stopColor="#8B6914"/>
        </radialGradient>
      </defs>
    </svg>
  );
}
